<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="bg-white rounded p-2 shadow-md custom-size h-auto">
    <div class="d-flex align-items-center">
      <div class="mr-1">
        <GjIcon
          :name="iconName"
          size="25"
          :class="iconColor"
        />
      </div>
      <h5 :class="infoTitleClass">
        {{ infoTitle }}
      </h5>
    </div>
    <div
      v-for="item in description"
      :key="item.id"
      :class="descriptionClass"
      class="my-2 custom-width"
    >
      <p
        class="text-lg"
        v-html="item.description"
      />
    </div>
  </div>
</template>
<script>

export default {
  props: {
    iconName: {
      type: String,
      default: '',
    },
    iconColor: {
      type: String,
      default: '',
    },
    infoTitle: {
      type: String,
      default: 'a',
    },
    infoTitleClass: {
      type: String,
      default: '',
    },
    description: {
      type: Array,
      default: () => ([]),
    },
    descriptionClass: {
      type: String,
      default: '',
    },

  },
  data() {
    return {

    }
  },
}
</script>

<style lang="scss" scoped>
@import "@/../GjirafaFront/style/theme.scss";

.shadow-md{
  box-shadow: 0px 0px 10px 0px $gray-300;

}
.custom-size {
  height: 310px;
  overflow-y: auto;
}

</style>
